import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "bg-white border-b border-gray-100 shadow-sm py-8" }
const _hoisted_2 = { class: "max-w-6xl mx-auto px-6" }
const _hoisted_3 = { class: "hidden md:flex items-center justify-center" }
const _hoisted_4 = { class: "flex flex-col items-center gap-3" }
const _hoisted_5 = { class: "relative flex flex-col items-center min-w-[120px]" }
const _hoisted_6 = {
  key: 0,
  class: "w-2 h-2 bg-blue-500 rounded-full mt-2 animate-pulse"
}
const _hoisted_7 = {
  key: 0,
  class: "flex items-center min-w-[10rem] -mx-8 mb-4"
}
const _hoisted_8 = { class: "md:hidden flex justify-center mt-6" }
const _hoisted_9 = { class: "relative" }
const _hoisted_10 = { class: "w-20 h-20 rounded-full bg-white relative flex items-center justify-center" }
const _hoisted_11 = {
  class: "w-20 h-20 absolute inset-0 transform -rotate-90",
  viewBox: "0 0 80 80"
}
const _hoisted_12 = ["stroke-dasharray"]
const _hoisted_13 = { class: "text-center z-10" }
const _hoisted_14 = { class: "text-lg font-bold text-gray-800" }
const _hoisted_15 = { class: "text-xs text-gray-500" }

import type { StepperHeaderProps } from '@/types/sellerRegister';


export default /*@__PURE__*/_defineComponent({
  __name: 'StepperHeader',
  props: {
    steps: {},
    currentStep: {}
  },
  setup(__props: any) {

const props = __props;

const getStepClasses = (index: number) => {
  if (index <= props.currentStep) {
    return 'bg-blue-500 border-blue-500 text-white scale-105 shadow-lg shadow-blue-500/30';
  } else {
    return 'bg-white border-gray-300 text-gray-600';
  }
};

const getStepTitleClasses = (index: number) => {
  if (index === props.currentStep) {
    return 'text-blue-600 scale-105';
  } else if (index < props.currentStep || props.steps[index].completed) {
    return 'text-gray-900';
  } else {
    return 'text-gray-400';
  }
};

const getStepLineClasses = (index: number) => {
  if (index < props.currentStep) {
    return 'bg-blue-500';
  } else {
    return 'bg-gray-200';
  }
};

const getProgressArc = () => {
  // Calculer le pourcentage de progression basé sur l'étape actuelle
  const progressPercentage = (props.currentStep / props.steps.length) * 100;
  
  // Calculer la circonférence de l'arc (2 * π * r)
  const radius = 32;
  const circumference = 2 * Math.PI * radius;
  
  // Calculer la longueur de l'arc basée sur le pourcentage
  const arcLength = (progressPercentage / 100) * circumference;
  
  return arcLength;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.steps, (step, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            class: "flex items-center"
          }, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", {
                class: _normalizeClass(["flex items-center justify-center w-12 h-12 rounded-full border-2 transition-all duration-300 ease-in-out shadow-md", getStepClasses(index)])
              }, [
                _createElementVNode("span", {
                  class: _normalizeClass(["text-sm font-bold", index <= _ctx.currentStep ? 'text-white' : 'text-gray-600'])
                }, _toDisplayString(index + 1), 3)
              ], 2),
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("span", {
                  class: _normalizeClass(["text-sm font-semibold text-center transition-all duration-300 leading-tight", getStepTitleClasses(index)])
                }, _toDisplayString(step.title), 3),
                (index === _ctx.currentStep)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6))
                  : _createCommentVNode("", true)
              ])
            ]),
            (index < _ctx.steps.length - 1)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["w-full h-1 transition-all duration-300 ease-in-out rounded-full", getStepLineClasses(index)])
                  }, null, 2)
                ]))
              : _createCommentVNode("", true)
          ]))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            (_openBlock(), _createElementBlock("svg", _hoisted_11, [
              _createElementVNode("circle", {
                cx: "40",
                cy: "40",
                r: "32",
                fill: "none",
                stroke: "#10b981",
                "stroke-width": "6",
                "stroke-linecap": "round",
                "stroke-dasharray": `${getProgressArc()} 200`,
                class: "transition-all duration-500 ease-in-out"
              }, null, 8, _hoisted_12)
            ])),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.currentStep + 1), 1),
              _createElementVNode("div", _hoisted_15, "of " + _toDisplayString(_ctx.steps.length), 1)
            ])
          ])
        ])
      ])
    ])
  ]))
}
}

})